import script from "./ReportHoursView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportHoursView.vue?vue&type=script&setup=true&lang=ts"

import "./ReportHoursView.vue?vue&type=style&index=0&id=8479070c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8479070c"]])

export default __exports__